export default __webpack_public_path__ + "static/media/img_muslinTwoBunnyEars_rg_p.0a7b3eee.jpg";